// src/components/audition-booking-wizard/WizardStepper.jsx
import React from 'react';
import { WIZARD_STEPS } from './utils/bookingHelpers'; // Use dynamic steps

const WizardStepper = ({ currentStep, selectedMode, handleStepClick }) => {
    const steps = WIZARD_STEPS(selectedMode);
    const stepsCount = steps.length || 4;
    const centerOffsetPercent = (100 / (2 * stepsCount)).toFixed(2);

    return (
        <div className="wizard-stepper-container">
            <div className="step-indicator-wrapper">
                <div 
                    className="step-progress-track"
                    style={{
                        left: `${centerOffsetPercent}%`,
                        right: `${centerOffsetPercent}%`
                    }}
                ></div>
                {steps.map((label, i) => {
                    const stepNum = i + 1;
                    const isActive = currentStep >= stepNum;

                    return (
                        <div 
                            key={i} 
                            className={`step-item ${isActive ? 'active' : ''}`}
                            onClick={() => handleStepClick && handleStepClick(i)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="step-circle">{stepNum}</div>
                            <div className="step-label">{label}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default WizardStepper;